import { createSelector } from 'reselect'

const getDatetimes = (state, layerName) => {
  return state.layer.times[layerName]
}

const getFormatter = (state, layerName, formatter) => {
  return formatter || (value => new Date(value).toISOString())
}

export const makeGetDatetime = () => {
  return createSelector(
    [getDatetimes, getFormatter],
    (datetimes, formatter) => {      
      if (datetimes) {
        // console.log(datetimes)
        // console.log(formatter(datetimes))
        // console.log(formatter)
        return formatter(datetimes)
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/datetimeSelector.js